module.exports = require('./lib/websocket');